import Vue from "vue";
import {setSession, getSession, initRoutes} from "./methods";
import store from "../store";
import baseRoutes from "../router/baseRoutes";
import router from "../router";
import App from "@/App.vue";
import {allMenus} from "@/api/sysTem/menuAdmin";
import {allBIMenus, tokenOrToken} from "@/api/StatisticalManagement/StatisticalManagement";
import VXETable from 'vxe-table';
import request from "@/axios/index";

import en from '../lang/en'
import zh from '../lang/zh'
import th from '../lang/th'
import id from '../lang/id'
import ru from '../lang/ru'
import vie from '../lang/vie'

let language = null
if (getSession('LanguageName') == 'en') {
    language = en
} else if (getSession('LanguageName') == 'th') {
    language = th
} else if (getSession('LanguageName') == 'id') {
    language = id
} else if (getSession('LanguageName') == 'ru') {
    language = ru
} else if (getSession('LanguageName') == 'vie') {
    language = vie
} else if (getSession('LanguageName') == 'zh-cn') {
    language = zh
} else {
    language = zh
    sessionStorage.setItem('LanguageName', JSON.stringify('zh-cn'))
}

// 写死模块多语言配置
import i18n from './i18n.js'
import lang from './lang.js'

window.lang = lang
let vueThis = null
if (getSession('vue_admin_template_token')) {
    const token = getSession('vue_admin_template_token') || '';
    const modifiedToken = token.replace(/^Bearer /, '');

    tokenOrToken({ sysCode: "bs", token: modifiedToken, bsType: 1 }).then(tokenRes => {
        if (tokenRes.data && tokenRes.data.data && tokenRes.data.data.token) {
            setSession('BITOKEN', tokenRes.data.data.token);
            return Promise.allSettled([allMenus(), allBIMenus({ token: tokenRes.data.data.token })]);
        } else {
            return Promise.allSettled([allMenus(), Promise.resolve({ status: 'rejected', reason: 'No token' })]);
        }
    }).catch(() => {
        return Promise.allSettled([allMenus(), Promise.resolve({ status: 'rejected', reason: 'Token request failed' })]);
    }).then(async ([allMenusResult, allBIMenusResult]) => {
        let menusRoutes;
        let biMenusRoutes;
        if (allMenusResult.status === 'fulfilled') {
            menusRoutes = allMenusResult.value || [];
        } else {
            menusRoutes = [];
        }
        if (allBIMenusResult.status === 'fulfilled' && allBIMenusResult.value.data && allBIMenusResult.value.data.data.length > 0) {
            biMenusRoutes = allBIMenusResult.value.data.data;
        } else {
            biMenusRoutes = [];
        }
        if (biMenusRoutes.length > 0) {
            biMenusRoutes = biMenusRoutes.map(item => ({
                ...item,
                component: 'BILayout',
                path: `BILayout_${item.id}`,
                name: `BI_${item.id}`,
                title: item.dsName,
                isBILink: true,
                meta: {
                    icon: 'icon-chuangjianxitong',
                    title: item.dsName,
                    menuName: item.dsName,
                    keepAlive: true
                }
            }));
        }
        const processBIMenus = (menus) => {
            return menus.map(item => {
                const processedItem = {
                    ...item,
                    component: 'BILayout',
                    path: `BILayout_${item.id}`,
                    name: `BI_${item.id}`,
                    title: item.dsName,
                    isBILink: true,
                    meta: {
                        icon: 'icon-chuangjianxitong',
                        title: item.dsName,
                        menuName: item.dsName,
                        keepAlive: true
                    }
                };
                if (Array.isArray(item.children) && item.children.length > 0) {
                    processedItem.children = processBIMenus(item.children);
                }
                return processedItem;
            });
        };
        if (biMenusRoutes.length > 0) {
            biMenusRoutes = processBIMenus(biMenusRoutes);
        }
        const BIHomeRoutes = [{
            path: '/bi',
            name: 'BI',
            component: 'Loyout',
            isBILink: true,
            orderNum: 5000,
            meta: { title: language.configMoudle.BIStatement, icon: 'icon-xiaoshoubaobiao', keepAlive: true },
            children: biMenusRoutes
        }];
        let finalRoutes = [];


        async function switchBiModule() {
            let switchKeys = ["BIStatementSwitch"];
            // 返回一个 Promise，确保异步请求能够被处理
            try {
                const data = await request({
                url: `/global-config/get`,
                method: "post",
                data: switchKeys,
                });
                return data;
            } catch (error) {
                console.error('请求失败', error);
                throw error; // 抛出错误，以便外部捕获
            }
        }

        const data = await switchBiModule();
        if (data[0]) {
            store.dispatch("global/ROUTES_SET", [...baseRoutes, ...menusRoutes, ...BIHomeRoutes]);
            finalRoutes = [...menusRoutes, ...BIHomeRoutes];
        } else {
            store.dispatch("global/ROUTES_SET", [...baseRoutes, ...menusRoutes]);
            finalRoutes = [...menusRoutes];
        }
        router.addRoutes(initRoutes(finalRoutes));
        // 初始化 Vue 实例
        vueThis = new Vue({
            router,
            store,
            i18n,
            render: (h) => h(App),
        }).$mount("#app");
       
    }).catch(err => {
        console.error('Error loading menus or token:', err);
    });
} else {
    vueThis = new Vue({
        router,
        store,
        i18n,
        render: (h) => h(App),
    }).$mount("#app");
}

let tags = getSession("tags");
if (tags) {
    store.dispatch("global/TAG_ADD", tags);
}

let user = getSession("userInfo");
if (user) {
    store.commit("global/GET_USERINFO", user);
}

VXETable.setup({
    // 对组件内置的提示语进行国际化翻译
    i18n: (key, args) => i18n.t(key, args)
})
Vue.use(VXETable)
Vue.prototype.$VXETable = VXETable
export {
    vueThis,
    language
}
